import { render, staticRenderFns } from "./OrderReviewTotal.vue?vue&type=template&id=02e9073f&scoped=true&"
import script from "./OrderReviewTotal.vue?vue&type=script&lang=js&"
export * from "./OrderReviewTotal.vue?vue&type=script&lang=js&"
import style0 from "./OrderReviewTotal.vue?vue&type=style&index=0&id=02e9073f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e9073f",
  null
  
)

export default component.exports